import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  paper: {
    zIndex: '10000',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    width: '317px',
    height: '465px',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    boxShadow: '0 0 40px 0 rgba(0, 0, 0, 0.2)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '&:focus': {
      outline: 'none',
    },
    '@media screen and (max-width: 640px)': {
      width: '304px',
    },
  },
  iconCloseBtn: {
    margin: '5px 0 0 0',
  },
  closeIcon: {
    width: '16px',
  },
  title: {
    marginTop: '40px',
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: '20px',
    textAlign: 'center',
    color: '#000000',
    marginBottom: '16px',
  },
  subTitle: {
    fontFamily: 'Rubik',
    fontWeight: 'normal',
    fontSize: '16px',
    textAlign: 'center',
    color: '#252525',
    marginBottom: '16px',
  },
  inputCustom: {
    width: '240px',
  },
  townInput: {
    marginBottom: '16px',
    backgroundColor: '#ffffff',
    '& input': {
      backgroundColor: '#ffffff',
    },
    '& .react-geocoder-results': {
      backgroundColor: '#ffffff',
    },
  },
  loginCheckBox: {
    marginBottom: '24px',
    height: '40px',
    width: '240px',
    '& .MuiTypography-root': {
      fontFamily: 'Rubik',
      fontStyle: 'normal !important',
      fontWeight: 'normal !important',
      fontSize: '16px !important',
      color: '#252525 !important',
    },
  },
  checkBox: {
    color: '#525E69',
    height: '40px',
  },
  termsLink: {
    '& a': {
      textDecoration: 'underline',
      color: '#252525',
      cursor: 'pointer',
    },
  },
  btnRegister: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#FFFFFF',
    width: '238px',
    backgroundColor: '#B1B1B1',
    borderRadius: '8px',
    cursor: 'default',
    '&:hover': {
      backgroundColor: '#B1B1B1',
    },
  },
  btnRegisterActive: {
    backgroundColor: '#FC7855',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#EB6D4C',
    },
  },
}))
